import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type {
  PostingTemplateDto,
  PostingTemplateFilter,
} from "@/features/ledger/api/dto";

/**
 * Modèles d'imputation paginés (`POST /PostingTemplates/all`, guide §4.2) —
 * filtrables par code produit, provider et statut.
 */
export const usePostingTemplates = (
  params: ListRequest<PostingTemplateFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_POSTING_TEMPLATES_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.postingTemplates.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<PostingTemplateDto>>,
    enabled,
  });
